import React, { useEffect, useState } from 'react';
import { getMayorSettings } from '../../api/mayorSettings';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';

export default function MayorDuties() {


    const [mayorData, setMayorData] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchMayorData = async () => {
        try {
          const response = await getMayorSettings();
          console.log('Mayor API Response:', response);
          if (response.isSuccess && response.data) {
            setMayorData(response.data);
            console.log('Mayor Data:', response.data);
          }
        } catch (error) {
          console.error('Error fetching mayor data:', error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchMayorData();
    }, []);
  
    if (loading) {
      return <div className="loading">Loading...</div>;
    }

  return (
 <div className="mayor-page">
   
      <div className="container py-5">
        <div className="row">
        <QuickMenu />

        <div className="col-md-10">
        <div className="mayor-content">
          <div className="mayor-image">
            <img src="/assets/images/baskan-gorev.webp" alt="Belediye Başkanı" className="img-fluid" />
            <div className="mayor-social">
              {mayorData?.facebookUrl && mayorData.facebookUrl.trim() !== " " && (
                <a href={mayorData.facebookUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaFacebook size={24} />
                </a>
              )}
              {mayorData?.twitterUrl && mayorData.twitterUrl.trim() !== " " && (
                <a href={mayorData.twitterUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaTwitter size={24} />
                </a>
              )}
              {mayorData?.instagramUrl && mayorData.instagramUrl.trim() !== " " && (
                <a href={mayorData.instagramUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={24} />
                </a>
              )}
              {mayorData?.linkedinUrl && mayorData.linkedinUrl.trim() !== " " && (
                <a href={mayorData.linkedinUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin size={24} />
                </a>
              )}
              {mayorData?.youtubeUrl && mayorData.youtubeUrl.trim() !== " " && (
                <a href={mayorData.youtubeUrl} className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaYoutube size={24} />
                </a>
              )}
            </div>
          </div>
          
          <div className="mayor-bio">
          <h1 className="page-title">Başkanının Görev ve Yetkileri</h1>
            {/* <h2 className="mayor-name">{mayorData?.nameSurname}</h2>
            <h3 className="mayor-title">İskenderun Belediye Başkanı</h3> */}
            
            <div className="bio-content">
            <p>
      Belediye başkanının görev ve yetkileri, 13 Temmuz 2005 tarihinde 25874 Sayılı Resmi
      Gazete'de yayımlanarak yürürlüğe giren 5393 sayılı Belediye Kanunu'nun 38. maddesi ile
      belirlenmiştir.
    </p>
    <p>
      Buna göre, Belediye başkanı, belediye idaresinin başı ve belediye tüzel kişiliğinin
      temsilcisidir. Belediye başkanı, ilgili kanunda gösterilen esas ve usullere göre seçilir.
    </p>
    <p>
      Belediye başkanı, görevinin devamı süresince siyasi partilerin yönetim ve denetim
      organlarında görev alamaz; profesyonel spor kulüplerinin başkanlığını yapamaz ve
      yönetiminde bulunamaz.
    </p>
    <h2>Belediye Başkanının Görev ve Yetkileri</h2>
    <ul>
      <li>Belediye teşkilâtının en üst amiri olarak belediye teşkilâtını sevk ve idare etmek, belediyenin hak ve menfaatlerini korumak.</li>
      <li>Belediyeyi stratejik plâna uygun olarak yönetmek, belediye idaresinin kurumsal stratejilerini oluşturmak.</li>
      <li>Bütçeyi, belediye faaliyetlerinin ve personelinin performans ölçütlerini hazırlamak ve uygulamak.</li>
      <li>Belediyeyi Devlet dairelerinde ve törenlerde, davacı veya davalı olarak da yargı yerlerinde temsil etmek veya vekil tayin etmek.</li>
      <li>Meclise ve encümene başkanlık etmek.</li>
      <li>Belediyenin taşınır ve taşınmaz mallarını idare etmek.</li>
      <li>Belediyenin gelir ve alacaklarını takip ve tahsil etmek.</li>
      <li>Yetkili organların kararını almak şartıyla sözleşme yapmak.</li>
      <li>Meclis ve encümen kararlarını uygulamak.</li>
      <li>Bütçeyi uygulamak, bütçede meclis ve encümenin yetkisi dışındaki aktarmalara onay vermek.</li>
      <li>Belediye personelini atamak.</li>
      <li>Belediye ve bağlı kuruluşları ile işletmelerini denetlemek.</li>
      <li>Şartsız bağışları kabul etmek.</li>
      <li>Belde halkının huzur, esenlik, sağlık ve mutluluğu için gereken önlemleri almak.</li>
      <li>Bütçede yoksul ve muhtaçlar için ayrılan ödeneği kullanmak, özürlülere yönelik hizmetleri yürütmek ve özürlüler merkezini oluşturmak.</li>
      <li>Temsil ve ağırlama giderleri için ayrılan ödeneği kullanmak.</li>
      <li>Kanunlarla belediyeye verilen ve belediye meclisi veya belediye encümeni kararını gerektirmeyen görevleri yapmak ve yetkileri kullanmak.</li>
    </ul>
            </div>
          </div>
        </div>
        </div>
        </div>
        
       
      
      </div>
    </div>


  
 
  )
}
